import { render, staticRenderFns } from "./quick-add-button.vue?vue&type=template&id=f1cefa06&"
import script from "./quick-add-button.vue?vue&type=script&lang=ts&"
export * from "./quick-add-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports